import axios from 'axios';

export function fetchTrackerSettings() {
  return axios.get('/api/trackerSettings')
      .then((res) => res.data);
}

